"use client";

import { EdgeFade } from "@/components/edge-fade";
import { Button } from "@/components/ui/button";
import { Marquee } from "@/components/ui/marquee";
import { BLUR_DATA_URL } from "@/config/site";
import { FlightSerializers } from "@/feature/flight/search/lib/search";
import { MapPin, Plane } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { MouseEvent, useState, useTransition } from "react";

const popular_destinations = [
  {
    id: 1,
    agency_id: 8,
    thumbnail: "https://photos.nomadicnotes.com/img/s/v-3/p2759081374-4.jpg",
    order_number: 1,
    from_airport: 210,
    to_airport: 2061,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Cox's Bazar Airport",
    to_airport_code: "CXB",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Cox's Bazar",
  },
  {
    id: 14,
    agency_id: 8,
    thumbnail:
      "https://www.opulentroutes.com/wp-content/uploads/2021/04/Dhaka.jpg",
    order_number: 2,
    from_airport: 212,
    to_airport: 210,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Sylhet",
    from_airport_name: "Osmani International Airport",
    from_airport_code: "ZYL",
    to_airport_name: "Hazrat Shahjalal International Airport",
    to_airport_code: "DAC",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Dhaka",
  },
  {
    id: 19,
    agency_id: 8,
    thumbnail: "https://photos.nomadicnotes.com/img/s/v-3/p2759081374-4.jpg",
    order_number: 3,
    from_airport: 212,
    to_airport: 2061,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Sylhet",
    from_airport_name: "Osmani International Airport",
    from_airport_code: "ZYL",
    to_airport_name: "Cox's Bazar Airport",
    to_airport_code: "CXB",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Cox's Bazar",
  },
  {
    id: 23,
    agency_id: 8,
    thumbnail:
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0b/37/b1/f6/front-view-full.jpg?w=600&h=400&s=1",
    order_number: 4,
    from_airport: 891,
    to_airport: 2062,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Saidpur Airport",
    to_airport_code: "SPD",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Saidpur",
  },
  {
    id: 24,
    agency_id: 8,
    thumbnail:
      "https://media.istockphoto.com/id/2156283145/photo/the-port-of-chittagong-is-the-busiest-seaport-on-the-coastline-of-the-bay-of-bengal.jpg?s=612x612&w=0&k=20&c=YoG7pPcS-np4otikdGuEMRmOV5XI7HZ48EXKm9DvThA=",
    order_number: 5,
    from_airport: 2061,
    to_airport: 209,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Cox's Bazar",
    from_airport_name: "Cox's Bazar Airport",
    from_airport_code: "CXB",
    to_airport_name: "Shah Amanat International Airport",
    to_airport_code: "CGP",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Chittagong",
  },
  {
    id: 25,
    agency_id: 8,
    thumbnail:
      "https://www.opulentroutes.com/wp-content/uploads/2021/04/Dhaka.jpg",
    order_number: 6,
    from_airport: 2061,
    to_airport: 210,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Cox's Bazar",
    from_airport_name: "Cox's Bazar Airport",
    from_airport_code: "CXB",
    to_airport_name: "Hazrat Shahjalal International Airport",
    to_airport_code: "DAC",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Dhaka",
  },
  {
    id: 26,
    agency_id: 8,
    thumbnail:
      "https://media.istockphoto.com/id/2156283145/photo/the-port-of-chittagong-is-the-busiest-seaport-on-the-coastline-of-the-bay-of-bengal.jpg?s=612x612&w=0&k=20&c=YoG7pPcS-np4otikdGuEMRmOV5XI7HZ48EXKm9DvThA=",
    order_number: 7,
    from_airport: 2062,
    to_airport: 209,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Saidpur",
    from_airport_name: "Saidpur Airport",
    from_airport_code: "SPD",
    to_airport_name: "Shah Amanat International Airport",
    to_airport_code: "CGP",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Chittagong",
  },
  {
    id: 27,
    agency_id: 8,
    thumbnail:
      "https://ecdn.dhakatribune.net/contents/cache/images/640x0x1/uploads/media/2023/09/13/Rajshahi-Development-5-f6819dd6ea94084fd01a011dac7ca45d.jpg",
    order_number: 12,
    from_airport: 2062,
    to_airport: 2058,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Shah Makhdum Airport-Rajshahi",
    to_airport_code: "RJH",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Rajshahi",
  },
  {
    id: 28,
    agency_id: 8,
    thumbnail:
      "https://www.thelandofsnows.com/wp-content/uploads/2018/12/Kathesimbhu-stupa-Nepal-1024x683.jpg",
    order_number: 9,
    from_airport: 1352,
    to_airport: 996,
    status: true,
    from_airport_country: "UNITED ARAB EMIRATES",
    from_airport_city: "Sharjah",
    from_airport_name: "Sharjah International Airport",
    from_airport_code: "SHJ",
    to_airport_name: "Tribhuvan International Airport",
    to_airport_code: "KTM",
    to_airport_country: "NEPAL",
    to_airport_city: "Kathmandu",
  },
  {
    id: 29,
    agency_id: 8,
    thumbnail:
      "https://www.thelandofsnows.com/wp-content/uploads/2018/12/Kathesimbhu-stupa-Nepal-1024x683.jpg",
    order_number: 10,
    from_airport: 210,
    to_airport: 996,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Tribhuvan International Airport",
    to_airport_code: "KTM",
    to_airport_country: "NEPAL",
    to_airport_city: "Kathmandu",
  },
  {
    id: 30,
    agency_id: 8,
    thumbnail:
      "https://media.istockphoto.com/id/2156283145/photo/the-port-of-chittagong-is-the-busiest-seaport-on-the-coastline-of-the-bay-of-bengal.jpg?s=612x612&w=0&k=20&c=YoG7pPcS-np4otikdGuEMRmOV5XI7HZ48EXKm9DvThA=",
    order_number: 11,
    from_airport: 2061,
    to_airport: 209,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Cox's Bazar",
    from_airport_name: "Cox's Bazar Airport",
    from_airport_code: "CXB",
    to_airport_name: "Shah Amanat International Airport",
    to_airport_code: "CGP",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Chittagong",
  },
  {
    id: 31,
    agency_id: 8,
    thumbnail:
      "https://ecdn.dhakatribune.net/contents/cache/images/640x0x1/uploads/media/2023/09/13/Rajshahi-Development-5-f6819dd6ea94084fd01a011dac7ca45d.jpg",
    order_number: 12,
    from_airport: 2062,
    to_airport: 2058,
    status: true,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Saidpur",
    from_airport_name: "Saidpur Airport",
    from_airport_code: "SPD",
    to_airport_name: "Shah Makhdum Airport-Rajshahi",
    to_airport_code: "RJH",
    to_airport_country: "BANGLADESH",
    to_airport_city: "Rajshahi",
  },
];

function getDefaultDepartureDate() {
  const now = new Date();
  const departure = new Date(now);

  if (now.getHours() >= 18) {
    departure.setDate(departure.getDate() + 1);
  }

  const year = departure.getFullYear();
  const month = String(departure.getMonth() + 1).padStart(2, "0");
  const day = String(departure.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export const PopularDestination = () => {
  const router = useRouter();
  const [activeCardId, setActiveCardId] = useState<number | null>(null);
  const [isPending, startTransition] = useTransition();

  const getFlightHref = (destination: (typeof popular_destinations)[number]) => {
    const departDate = getDefaultDepartureDate();
    const route = FlightSerializers.flights([
      {
        from: {
          iata_code: destination.from_airport_code,
          name: destination.from_airport_name,
          city_name: destination.from_airport_city,
          country: destination.from_airport_country,
        },
        to: {
          iata_code: destination.to_airport_code,
          name: destination.to_airport_name,
          city_name: destination.to_airport_city,
          country: destination.to_airport_country,
        },
        departDate,
      },
    ]);

    const searchParams = new URLSearchParams({ trip: "oneway", route });
    return `/flights?${searchParams.toString()}`;
  };

  const handleCardNavigation = (
    event: MouseEvent<HTMLAnchorElement>,
    destination: (typeof popular_destinations)[number],
    href: string
  ) => {
    event.preventDefault();

    if (isPending) {
      return;
    }

    setActiveCardId(destination.id);
    startTransition(() => {
      router.push(href);
    });
  };

  return (
    <>
      <div>
        <h2 className="text-3xl font-bold mb-2">Popular Destinations</h2>
        <p className="mb-4 max-w-2xl text-muted-foreground">
          Explore our most sought-after destinations, curated for unforgettable
          experiences.
        </p>
      </div>
      <div className="relative overflow-hidden pt-10">
        <EdgeFade xSizeClass="w-20" />

        <Marquee pauseOnHover>
          {popular_destinations.map((destination) => {
            const href = getFlightHref(destination);
            const isCardLoading = isPending && activeCardId === destination.id;

            return (
              <Link
                key={destination.id}
                href={href}
                onClick={(event) =>
                  handleCardNavigation(event, destination, href)
                }
                aria-disabled={isPending}
                tabIndex={isPending ? -1 : undefined}
                className={`group relative h-70 w-56 shrink-0 overflow-hidden rounded-2xl border-0 shadow-xl transition-all duration-500 md:w-60 ${
                  isPending
                    ? "cursor-not-allowed pointer-events-none"
                    : "cursor-pointer hover:-translate-y-2 hover:shadow-2xl"
                }`}
              >
                {/* Background Image */}
                <div className="absolute inset-0">
                  {destination.thumbnail && (
                    <Image
                      src={destination.thumbnail}
                      alt={`Flights from ${destination.from_airport_city} to ${destination.to_airport_city}`}
                      fill
                      className="object-cover opacity-90 group-hover:opacity-70 group-hover:scale-110 transition-all duration-700"
                      sizes="(max-width: 768px) 224px, 240px"
                      quality={70}
                      placeholder="blur"
                      blurDataURL={BLUR_DATA_URL}
                      loading="lazy"
                    />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/95 via-slate-900/40 to-slate-900/10" />
                  {/* Subtle overlay on hover */}
                  <div className="absolute inset-0 bg-gradient-to-br from-sky-500/0 to-cyan-500/0 group-hover:from-sky-500/20 group-hover:to-cyan-500/20 transition-all duration-500" />
                </div>

                {isCardLoading && (
                  <div className="absolute inset-0 z-10 grid place-items-center bg-slate-900/65 backdrop-blur-[1px]">
                    <div className="rounded-full border border-white/30 bg-white/10 px-3 py-1 text-xs font-semibold text-white animate-pulse">
                      Loading fares...
                    </div>
                  </div>
                )}

                {/* Content Overlay */}
                <div className="absolute inset-0 flex flex-col justify-between p-4">
                  {/* Origin Badge (Top Left) */}
                  <div className="self-start">
                    <div className="flex items-center gap-2 rounded-full bg-gradient-to-r from-sky-500 to-cyan-500 px-3 py-2 shadow-lg ring-2 ring-white/30">
                      <div className="bg-white/20 rounded-full p-1">
                        <Plane
                          className="w-3 h-3 text-white -rotate-45"
                          strokeWidth={2.5}
                        />
                      </div>
                      <div className="flex flex-col">
                        <span className="text-[9px] text-white/80 uppercase tracking-wider font-medium">
                          From
                        </span>
                        <span className="text-xs font-bold text-white leading-none">
                          {destination.from_airport_city}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Destination Info (Bottom) */}
                  <div className="space-y-2 translate-y-1 transition-transform duration-300 group-hover:translate-y-0">
                    <div className="flex items-center gap-2 text-background mb-1">
                      <div className="h-px flex-1 bg-gradient-to-r from-transparent via-white/40 to-transparent"></div>
                      {/* Destination icon */}
                      <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full p-1.5 shadow-md ring-2 ring-white/30">
                        <MapPin
                          className="w-3 h-3 text-white"
                          strokeWidth={2.5}
                        />
                      </div>
                      <div className="h-px flex-1 bg-gradient-to-r from-transparent via-white/40 to-transparent"></div>
                    </div>

                    <div className="text-center">
                      <h3 className="text-xl md:text-2xl font-bold font-satisfy text-background drop-shadow-md leading-tight">
                        {destination.to_airport_city}
                      </h3>
                      <p className="text-[10px] uppercase tracking-widest text-muted mt-1">
                        {destination.to_airport_country}
                      </p>
                    </div>

                    <div className="pt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <Button
                        variant="outline"
                        className="w-full cursor-pointer pointer-events-none"
                      >
                        Check Fares
                      </Button>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </Marquee>
      </div>
    </>
  );
};
